import { RG_TYPE } from '../../types/rg-type.js';

const genericInstance = {
    name: 'generic space instance',
    source: '',
    conditions: {},
    attributes: {}
};
const DefaultTechnicalSpaceRoom = {
    type: RG_TYPE.TechnicalSpaceRoom,
    color: '#E0E0CD',
    size: [3.0, 2.5, 7.5],
    anchor: [0.5, 0, 0.5],
    name: 'technical space room',
    children: [],
    data: { instance: genericInstance }
};

export { DefaultTechnicalSpaceRoom };
//# sourceMappingURL=default-technical-space-room.js.map
